export default "__VITE_ASSET__CJnuhTJl__"